import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSchools } from './api';

const initialState = {
  schools: undefined,
  status: 'idle',
};

export const getSchools = createAsyncThunk(
  'school/fetchSchools',
  async () => {
    const response = await fetchSchools();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const schoolSlice = createSlice({
  name: 'school',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // increment: (state) => {state.value += 1;},
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getSchools.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSchools.fulfilled, (state, action) => {
        state.status = 'idle';
        state.schools = action.payload;
      })
      .addCase(getSchools.rejected, (state, action) => {
        console.log('ERROR', action)
      })
  },
});

// export const { increment, decrement, incrementByAmount } = schoolSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.school.value)`
export const selectSchools = (state) => state.school.schools;

export default schoolSlice.reducer;
